import { http } from './config'

export default {
  listarclasse:() => {
    return http.get('classe_prods.php')
  }
}